"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SankeyOptions = /** @class */ (function () {
    function SankeyOptions() {
        this.width = 500;
        this.height = 300;
        this.data = Promise.resolve({});
        this.color = ["#30c4c4", "#008d8d", "#0fb5b5", "#53d4d4", "#83e5e5"];
    }
    return SankeyOptions;
}());
exports.default = SankeyOptions;
